import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "news-ticker-wrapper"
}
const _hoisted_2 = { class: "news-ticker-container" }
const _hoisted_3 = { class: "news-ticker-content" }
const _hoisted_4 = { class: "news-ticker-track" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  id: "content",
  class: "section bg-transparent my-0 py-0"
}
const _hoisted_8 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row border-between" }
const _hoisted_11 = { class: "col-lg-5" }
const _hoisted_12 = { class: "row posts-md col-mb-30" }
const _hoisted_13 = {
  key: 2,
  id: "content",
  class: "section bg-transparent my-0 py-0"
}
const _hoisted_14 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row border-between" }
const _hoisted_17 = { class: "col-lg-7 mb-5 mb-lg-0" }
const _hoisted_18 = { class: "entry border-bottom-0 mb-0" }
const _hoisted_19 = { class: "entry-image" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "entry-title" }
const _hoisted_23 = { class: "entry-categories" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "entry-meta" }
const _hoisted_27 = { href: "#" }
const _hoisted_28 = { class: "entry-content" }
const _hoisted_29 = { class: "col-lg-5" }
const _hoisted_30 = { class: "row posts-md col-mb-30" }
const _hoisted_31 = { class: "grid-inner row gutter-20" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "col-md-8" }
const _hoisted_36 = { class: "entry-title title-xs" }
const _hoisted_37 = { class: "entry-categories" }
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "entry-meta" }
const _hoisted_41 = { href: "#" }
const _hoisted_42 = {
  key: 3,
  id: "content",
  class: "section dark my-0 py-0"
}
const _hoisted_43 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_44 = { class: "container" }
const _hoisted_45 = { class: "row border-between" }
const _hoisted_46 = { class: "col-lg-5" }
const _hoisted_47 = { class: "row posts-md col-mb-30" }
const _hoisted_48 = {
  key: 4,
  id: "content",
  class: "section dark my-0 py-0"
}
const _hoisted_49 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_50 = { class: "container" }
const _hoisted_51 = { class: "row border-between" }
const _hoisted_52 = { class: "col-lg-7 mb-5 mb-lg-0" }
const _hoisted_53 = { class: "entry border-bottom-0 mb-0" }
const _hoisted_54 = { class: "entry-image" }
const _hoisted_55 = ["href"]
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = { class: "entry-title" }
const _hoisted_58 = { class: "entry-categories" }
const _hoisted_59 = ["href"]
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "entry-meta" }
const _hoisted_62 = { href: "#" }
const _hoisted_63 = { class: "entry-content" }
const _hoisted_64 = { class: "col-lg-5" }
const _hoisted_65 = { class: "row posts-md col-mb-30" }
const _hoisted_66 = { class: "grid-inner row gutter-20" }
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = ["href"]
const _hoisted_69 = ["src", "alt"]
const _hoisted_70 = { class: "col-md-8" }
const _hoisted_71 = { class: "entry-title title-xs" }
const _hoisted_72 = { class: "entry-categories" }
const _hoisted_73 = ["href"]
const _hoisted_74 = ["href"]
const _hoisted_75 = { class: "entry-meta" }
const _hoisted_76 = { href: "#" }
const _hoisted_77 = {
  id: "content",
  class: "section bg-transparent my-0 py-0"
}
const _hoisted_78 = {
  class: "content-wrap pt-5",
  style: {"overflow":"visible"}
}
const _hoisted_79 = { class: "container" }
const _hoisted_80 = { class: "content-wrap" }
const _hoisted_81 = { class: "container mw-lg py-lg-5" }
const _hoisted_82 = { class: "text-center mb-5 mb-lg-6" }
const _hoisted_83 = { class: "display-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isApiCallInProgress && _ctx.recentPosts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "news-ticker-item ticker-tagline" }, [
                  _createElementVNode("span", { class: "ticker-tagline-text" }, " Enterprise-Grade Nonsense Since 2025 "),
                  _createElementVNode("span", { class: "ticker-separator" }, "•")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentPosts, (post) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: 'ticker-' + post.id,
                    class: "news-ticker-item"
                  }, [
                    _createElementVNode("a", {
                      href: "/post/" + encodeURIComponent(post.attributes.slug),
                      class: "ticker-link"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(post.attributes.category.data.attributes.name) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(post.attributes.title), 1)
                    ], 8, _hoisted_5),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ticker-separator" }, "•", -1))
                  ]))
                }), 128)),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "news-ticker-item ticker-tagline" }, [
                  _createElementVNode("span", { class: "ticker-tagline-text" }, " Enterprise-Grade Nonsense Since 2025 "),
                  _createElementVNode("span", { class: "ticker-separator" }, "•")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentPosts, (post) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: 'ticker-duplicate-' + post.id,
                    class: "news-ticker-item"
                  }, [
                    _createElementVNode("a", {
                      href: "/post/" + encodeURIComponent(post.attributes.slug),
                      class: "ticker-link"
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(post.attributes.category.data.attributes.name) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(post.attributes.title), 1)
                    ], 8, _hoisted_6),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ticker-separator" }, "•", -1))
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isApiCallInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-7 mb-5 mb-lg-0" }, [
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"background-color":"#e0e0e0","aspect-ratio":"16/9"}
                  }),
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"height":"2em","width":"60%","background-color":"#e0e0e0","margin-top":"1em"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Recent Posts", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (i) => {
                      return _createElementVNode("article", {
                        class: "entry col-12",
                        key: i
                      }, [...(_cache[4] || (_cache[4] = [
                        _createStaticVNode("<div class=\"grid-inner row gutter-20\" data-v-bbaa27e0><div class=\"col-md-4\" data-v-bbaa27e0><a class=\"entry-image\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"background-color:#e0e0e0;aspect-ratio:16/9;\" data-v-bbaa27e0></div></a></div><div class=\"col-md-8\" data-v-bbaa27e0><div class=\"entry-title title-xs\" data-v-bbaa27e0><div class=\"entry-categories\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:1.2em;width:80%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-bbaa27e0></div></div><h3 data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:2em;width:100%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-bbaa27e0></div></h3></div><div class=\"entry-meta\" data-v-bbaa27e0><ul data-v-bbaa27e0><li data-v-bbaa27e0><a href=\"#\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:1.2em;width:60%;background-color:#e0e0e0;\" data-v-bbaa27e0></div></a></li></ul></div></div></div>", 1)
                      ]))])
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("article", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("a", {
                        href: "/post/" + encodeURIComponent(_ctx.recentPosts[0]?.attributes.slug)
                      }, [
                        _createElementVNode("img", {
                          src: this.getLargestMediaUrl(_ctx.recentPosts[0]?.attributes.thumbnail.data),
                          loading: "lazy",
                          alt: _ctx.recentPosts[0]?.attributes.thumbnail?.data?.attributes?.alternativeText || _ctx.recentPosts[0]?.attributes.thumbnail?.data?.attributes?.caption || _ctx.recentPosts[0]?.attributes.title || 'Article image',
                          class: "image-preview"
                        }, null, 8, _hoisted_21)
                      ], 8, _hoisted_20)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("a", {
                          href: "/post/category/" + _ctx.recentPosts[0]?.attributes.category.data.attributes.name
                        }, _toDisplayString(_ctx.recentPosts[0]?.attributes.category.data.attributes.name), 9, _hoisted_24)
                      ]),
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          href: "/post/" + encodeURIComponent(_ctx.recentPosts[0]?.attributes.slug),
                          class: "stretched-link color-underline"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.recentPosts[0]?.attributes.title), 1)
                        ], 8, _hoisted_25)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.convertTimeToDate(_ctx.recentPosts[0]?.attributes.createdAt)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.recentPosts[0]?.attributes.description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Recent Posts", -1)),
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentPosts.slice(1, 5), (post) => {
                      return (_openBlock(), _createElementBlock("article", {
                        class: "entry col-12",
                        key: post.id
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("a", {
                              class: "entry-image",
                              href: "/post/" + encodeURIComponent(post.attributes.slug)
                            }, [
                              _createElementVNode("img", {
                                src: this.getLargestMediaUrl(post.attributes.thumbnail.data),
                                alt: post.attributes.thumbnail?.data?.attributes?.alternativeText || post.attributes.thumbnail?.data?.attributes?.caption || post.attributes.title || 'Article image'
                              }, null, 8, _hoisted_34)
                            ], 8, _hoisted_33)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("a", {
                                  href: "/post/category/" + post.attributes.category.data.attributes.name
                                }, _toDisplayString(post.attributes.category.data.attributes.name), 9, _hoisted_38)
                              ]),
                              _createElementVNode("h3", null, [
                                _createElementVNode("a", {
                                  href: "/post/" + encodeURIComponent(post.attributes.slug),
                                  class: "stretched-link color-underline"
                                }, _toDisplayString(post.attributes.title), 9, _hoisted_39)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.convertTimeToDate(post.attributes.createdAt)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])),
    (_ctx.isApiCallInProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "font-body fw-medium" }, "Popular", -1)),
              _createElementVNode("div", _hoisted_45, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-lg-7 mb-5 mb-lg-0" }, [
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"background-color":"#e0e0e0","aspect-ratio":"16/9"}
                  }),
                  _createElementVNode("div", {
                    class: "loading-placeholder",
                    style: {"height":"2em","width":"60%","background-color":"#e0e0e0","margin-top":"1em"}
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_46, [
                  _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Highlights", -1)),
                  _createElementVNode("div", _hoisted_47, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (i) => {
                      return _createElementVNode("article", {
                        class: "entry col-12",
                        key: i
                      }, [...(_cache[8] || (_cache[8] = [
                        _createStaticVNode("<div class=\"grid-inner row gutter-20\" data-v-bbaa27e0><div class=\"col-md-4\" data-v-bbaa27e0><a class=\"entry-image\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"background-color:#e0e0e0;aspect-ratio:16/9;\" data-v-bbaa27e0></div></a></div><div class=\"col-md-8\" data-v-bbaa27e0><div class=\"entry-title title-xs\" data-v-bbaa27e0><div class=\"entry-categories\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:1.2em;width:80%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-bbaa27e0></div></div><h3 data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:2em;width:100%;background-color:#e0e0e0;margin-bottom:1em;\" data-v-bbaa27e0></div></h3></div><div class=\"entry-meta\" data-v-bbaa27e0><ul data-v-bbaa27e0><li data-v-bbaa27e0><a href=\"#\" data-v-bbaa27e0><div class=\"loading-placeholder\" style=\"height:1.2em;width:60%;background-color:#e0e0e0;\" data-v-bbaa27e0></div></a></li></ul></div></div></div>", 1)
                      ]))])
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "font-body fw-medium" }, "Popular", -1)),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("article", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("a", {
                        href: "/post/" + encodeURIComponent(_ctx.popularPosts[0]?.attributes.slug)
                      }, [
                        _createElementVNode("img", {
                          src: this.getLargestMediaUrl(_ctx.popularPosts[0]?.attributes.thumbnail.data),
                          loading: "lazy",
                          alt: _ctx.popularPosts[0]?.attributes.thumbnail?.data?.attributes?.alternativeText || _ctx.popularPosts[0]?.attributes.thumbnail?.data?.attributes?.caption || _ctx.popularPosts[0]?.attributes.title || 'Article image',
                          class: "image-preview"
                        }, null, 8, _hoisted_56)
                      ], 8, _hoisted_55)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("a", {
                          href: "/post/category/" + _ctx.popularPosts[0]?.attributes.category.data.attributes.name
                        }, _toDisplayString(_ctx.popularPosts[0]?.attributes.category.data.attributes.name), 9, _hoisted_59)
                      ]),
                      _createElementVNode("h3", null, [
                        _createElementVNode("a", {
                          href: "/post/" + encodeURIComponent(_ctx.popularPosts[0]?.attributes.slug),
                          class: "stretched-link color-underline"
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.popularPosts[0]?.attributes.title), 1)
                        ], 8, _hoisted_60)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", _hoisted_62, _toDisplayString(_ctx.convertTimeToDate(_ctx.popularPosts[0]?.attributes.createdAt)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.popularPosts[0]?.attributes.description), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "font-body fw-medium mb-4 h4" }, "Highlights", -1)),
                  _createElementVNode("div", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularPosts.slice(1, 5), (post) => {
                      return (_openBlock(), _createElementBlock("article", {
                        class: "entry col-12",
                        key: post.id
                      }, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("a", {
                              class: "entry-image",
                              href: "/post/" + encodeURIComponent(post.attributes.slug)
                            }, [
                              _createElementVNode("img", {
                                src: this.getLargestMediaUrl(post.attributes.thumbnail.data),
                                alt: post.attributes.thumbnail?.data?.attributes?.alternativeText || post.attributes.thumbnail?.data?.attributes?.caption || post.attributes.title || 'Article image'
                              }, null, 8, _hoisted_69)
                            ], 8, _hoisted_68)
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("a", {
                                  href: "/post/category/" + post.attributes.category.data.attributes.name
                                }, _toDisplayString(post.attributes.category.data.attributes.name), 9, _hoisted_73)
                              ]),
                              _createElementVNode("h3", null, [
                                _createElementVNode("a", {
                                  href: "/post/" + encodeURIComponent(post.attributes.slug),
                                  class: "stretched-link color-underline"
                                }, _toDisplayString(post.attributes.title), 9, _hoisted_74)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", _hoisted_76, _toDisplayString(_ctx.convertTimeToDate(post.attributes.createdAt)), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("h1", _hoisted_83, _toDisplayString(_ctx.appConfigs.general.metadata.home), 1)
              ]),
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"clear\" data-v-bbaa27e0></div><div class=\"row grid-border justify-content-center mt-3\" data-v-bbaa27e0><div class=\"col-lg-4 col-padding py-lg-0\" data-v-bbaa27e0><h3 class=\"mb-1 fw-semibold\" data-v-bbaa27e0>Become an Author</h3><p class=\"mb-5\" data-v-bbaa27e0>Have something insightful, funny, or thought-provoking to share? Join our community of writers and publish your own articles.</p><div class=\"row flex-column gy-1 list-link\" data-v-bbaa27e0><a href=\"/about#contact\" class=\"fw-medium link-dark h-text-primary\" data-v-bbaa27e0><u data-v-bbaa27e0>Submit Post</u></a></div></div><div class=\"col-lg-4 col-padding py-lg-0\" data-v-bbaa27e0><h3 class=\"mb-1 fw-semibold\" data-v-bbaa27e0>Community</h3><p class=\"mb-5\" data-v-bbaa27e0>Engage with like-minded developers, share experiences, and contribute to discussions about whatever.</p><div class=\"row flex-column gy-1 list-link\" data-v-bbaa27e0><a href=\"/community\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-bbaa27e0><u data-v-bbaa27e0>Join the Community</u></a></div></div><div class=\"col-lg-4 col-padding py-lg-0\" data-v-bbaa27e0><h3 class=\"mb-1 fw-semibold\" data-v-bbaa27e0>Contact Us</h3><p class=\"mb-5\" data-v-bbaa27e0>Have questions or feedback? Reach out to us—we’d love to hear from you!</p><div class=\"row flex-column gy-1 list-link\" data-v-bbaa27e0><a href=\"/about#contact\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-bbaa27e0><u data-v-bbaa27e0>Contact Us</u></a><a href=\"/about#contact\" class=\"mb-2 fw-medium link-dark h-text-primary\" data-v-bbaa27e0><u data-v-bbaa27e0>Report Content</u></a></div></div></div>", 2))
            ])
          ])
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div id=\"content\" class=\"section bg-transparent my-0 py-0\" data-v-bbaa27e0><div class=\"content-wrap pt-5\" data-v-bbaa27e0><div class=\"container\" data-v-bbaa27e0><div class=\"container-fluid\" data-v-bbaa27e0><div class=\"row justify-content-center mx-auto mw-md gx-5\" data-v-bbaa27e0><div class=\"col\" data-v-bbaa27e0><p class=\"h6 mb-0\" data-v-bbaa27e0> This site and its community are designed for entertainment and engagement. While we strive for accuracy in our content, occasional errors may occur, and community contributions reflect individual opinions, not the views of the site. If you have inquiries, wish to rectify misinformation, or seek clarification about our community, feel free to <a href=\"/about#contact\" data-v-bbaa27e0>Contact Us</a>. </p></div></div></div></div></div></div>", 1))
  ], 64))
}